import { render, staticRenderFns } from "./PaymentDisputesDetailModal.vue?vue&type=template&id=73ec1b4c&scoped=true&"
import script from "./PaymentDisputesDetailModal.vue?vue&type=script&lang=js&"
export * from "./PaymentDisputesDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./PaymentDisputesDetailModal.vue?vue&type=style&index=0&id=73ec1b4c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ec1b4c",
  null
  
)

export default component.exports